import { IEntityDetails } from "src/app/core/interfaces/entity.interface";
import { v4 } from "uuid";

export type EntityDetailsStateModel = IEntityDetails

export const generateBlankEntityDetails = (): EntityDetailsStateModel => {
  return {
    id: v4(),
    auditLog: [],
    filings: [],
    userIds: [],
    secureFileTransferComplete: false,
    orgId: "",
    jwtToken: "",
    ownerIds: [],
  };
};
